import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const bloodOrSkinDisease: AnswerPathTreeNode = {
  path: 'bloodOrSkinDisease',
  children: [
    {
      path: 'hadConsultationTreatmentForBloodOrSkinDisease',
      nodeId: NodeIds.healthInsuredHadConsultationTreatmentForBloodOrSkinDisease,
    },
    {
      path: 'hadConsultationTreatmentForBloodOrSkinDiseaseDetails',
      nodeId: NodeIds.healthInsuredHadConsultationTreatmentForBloodOrSkinDiseaseDetails,
    },
    {
      path: 'consultationTreatmentForBloodDiseaseDetails',
      nodeId: NodeIds.healthInsuredHadConsultationTreatmentForBloodDiseaseDetails,
    },
    {
      path: 'consultationTreatmentForSkinDiseaseDetails',
      nodeId: NodeIds.healthInsuredHadConsultationTreatmentForSkinDiseaseDetails,
    },
  ],
};
